import React from 'react'

function TendertextNozzle() {
  return (
    <embed src="\pdfs\EAT1.2.3.2_DW-V2-_-DR_Twist_nozzle_kr.pdf" width="100%" height="2100px" />
  )
}

export default TendertextNozzle